import { FC } from "react";
import { styled } from "@mui/system";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import { Span } from "../Typography";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import { twoColumnTableData } from "../../utils/constant-data";

const StyledTable = styled(Table)(({ theme }) => ({
  "& th, td": {
    padding: ".75rem",
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    background: theme.palette.mode === "light" && "white",
  },
  "& th": {
    fontWeight: "bold",
    background: theme.palette.mode === "light" && theme.palette.grey[100],
    borderBottom: `2px solid ${theme.palette.grey[300]}`,
  },
  "& td": {
    borderBottom: "none",
  },
}));

const Status = styled(Span)<{ status: string }>(({ theme, status }) => ({
  fontSize: 11,
  borderRadius: 5,
  padding: "1px 5px",
  color:
    status === "In Stock"
      ? theme.palette.success.main
      : status === "Out of Stock"
      ? "red"
      : status === "Low Stock"
      ? theme.palette.warning.main
      : theme.palette.primary.main,
}));

const TwoColumnTable: FC = () => {
  return (
    <>
      <StyledTable>
        <TableHead>
          <TableRow>
            <TableCell align="left">Item</TableCell>
            <TableCell align="left">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {twoColumnTableData.map((item, index) => (
            <TableRow key={index}>
              <TableCell align="left">{item.name}</TableCell>
              <TableCell align="left">
                <Status status={item.status}>{item.status}</Status>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </>
  );
};

export default TwoColumnTable;
